

import __layout_0 from '/home/runner/work/careezy-ui/careezy-ui/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/blank.vue'),
'branch': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/branch.vue'),
'default': __layout_0,
'owner': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/owner.vue'),
'components/BranchLayoutWithHorizontalNav': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/BranchLayoutWithHorizontalNav.vue'),
'components/BranchLayoutWithVerticalNav': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/BranchLayoutWithVerticalNav.vue'),
'components/BranchUserProfile': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/BranchUserProfile.vue'),
'components/DefaultLayoutWithHorizontalNav': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/Footer.vue'),
'components/HorizontalUserProfile': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/HorizontalUserProfile.vue'),
'components/NavBarNotifications': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/NavBarNotifications.vue'),
'components/NavBarTenants': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/NavBarTenants.vue'),
'components/NavSearchBar': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/home/runner/work/careezy-ui/careezy-ui/src/layouts/components/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
